/* eslint-env browser */

'use strict';

require('./index.styl');

require('../base/index.js');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

jsInitializer
  .addJsFiles(critModules, nonCritModules, pageReadyModules)
  .initIfReady('local');
